export default "__VITE_ASSET__CCwypBAM__"